import axios from "axios";
import { useAuthStore } from "@/store/authStore";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/ld+json",
  },
});

// ✅ Handle Unauthorized Errors (401) with a single interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const authStore = useAuthStore();
      authStore.logout();

      localStorage.removeItem("auth_token");
      localStorage.removeItem("userData");

      if (window.location.pathname !== "/signin") {
        window.location.href = "/signin";
      }
    }
    return Promise.reject(error);
  }
);

// ✅ PATCH Requests with Auth
api.patch = async (url, data, config = {}) => {
  try {
    const token = localStorage.getItem("auth_token");

    const headers = {
      "Content-Type": "application/merge-patch+json",
      Authorization: token ? `Bearer ${token}` : "",
      ...config.headers,
    };

    const response = await axios.patch(`${API_BASE_URL}${url}`, data, { ...config, headers });
    return response.data;
  } catch (error) {
    console.error("❌ PATCH Error:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ POST Requests with Auth
api.post = async (url, data, config = {}) => {
  try {
    const token = localStorage.getItem("auth_token");

    const headers = {
      "Content-Type": "application/ld+json",
      Authorization: token ? `Bearer ${token}` : "",
      ...config.headers,
    };

    const response = await axios.post(`${API_BASE_URL}${url}`, data, { ...config, headers });
    return response.data;
  } catch (error) {
    console.error("❌ POST Error:", error.response?.data || error.message);
    throw error;
  }
};

export default api;
